import DashboardContainer from 'components/feature/dashboard/DashboardContainer';

const HomePage = () => {
  return <DashboardContainer />;
};
export default HomePage;
